//
//
//
//
export default {
  name: "Name",
  components: {},
  props: [],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {},
  watch: {},
  filters: {}
};